import React from "react";
import PropTypes from "prop-types";
import { View, TouchableOpacity, StyleSheet } from "react-native";
import RadioIcon from "./icons/checkbox/RadioIcon";
import PartiallyCheckedIcon from "./icons/checkbox/PartiallyCheckedIcon";
import CheckedIcon from "./icons/checkbox/CheckedIcon";

const hitSlop = { top: 8, bottom: 8, left: 8, right: 8 };

const RoundCheckbox = (props) => {
  const {
    checked,
    isRadioChecked,
    hasChildrenChecked,
    onValueChange,
    size,
    backgroundColor,
    borderColor,
    style,
  } = props;

  const _onPress = () => {
    onValueChange(!checked);
  };

  const iconStyles = {
    borderWidth: 1,
    width: size,
    height: size,
    borderRadius: size / 2,
  };

  const checkedStyles = {
    backgroundColor,
    borderColor: backgroundColor,
    boxSizing: "content-box",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  return (
    <TouchableOpacity
      hitSlop={hitSlop}
      onPress={_onPress}
      style={[styles.parentWrapper, style]}
    >
      <View style={[checkedStyles, iconStyles]}>
        {isRadioChecked ? (
          <RadioIcon size={size} />
        ) : checked ? (
          hasChildrenChecked ? (
            <PartiallyCheckedIcon size={size} />
          ) : (
            <CheckedIcon size={size} />
          )
        ) : hasChildrenChecked ? (
          <PartiallyCheckedIcon size={size} color="gray" />
        ) : (
          <View
            style={[
              {
                borderColor,
                backgroundColor: "transparent",
              },
              iconStyles,
            ]}
          />
        )}
      </View>
    </TouchableOpacity>
  );
};

RoundCheckbox.propTypes = {
  onValueChange: PropTypes.func,
  icon: PropTypes.string,
  size: PropTypes.number,
  backgroundColor: PropTypes.string,
  iconColor: PropTypes.string,
  borderColor: PropTypes.string,
  checked: PropTypes.bool,
  style: PropTypes.object,
};

RoundCheckbox.defaultProps = {
  icon: "check",
  size: 20,
  backgroundColor: "transparent",
  iconColor: "white",
  borderColor: "grey",
  checked: false,
  onValueChange: () => {},
};

export default RoundCheckbox;

const styles = StyleSheet.create({
  parentWrapper: {
    position: "relative",
    width: 40,
    height: 40,
    justifyContent: "center",
    alignItems: "center",
  },
  commonWrapperStyles: {
    justifyContent: "center",
    alignItems: "center",
  },
});
